// extracted by mini-css-extract-plugin
module.exports = {"root":"CertificationGrid_root__vPDVB","layout":"CertificationGrid_layout__nwN6z","rotation":"CertificationGrid_rotation__Ihl4Z"};